$(function() {
  $('nav > ul.nav > li.with-submenu').click(function() {
    if ($('nav > ul.nav > li.with-submenu > ul').is(':visible')) {
      $('nav > ul.nav > li.with-submenu > ul').hide()
    }
    $(this).children('ul').show()
  })

  $(document).click(function(event) {
    if (!$(event.target).closest('li.with-submenu').length) {
      if ($('li.with-submenu > ul').is(':visible')) {
        $('li.with-submenu > ul').hide()
      }
    }
  })
})
